/* eslint-disable camelcase */
import React from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import Button from '../../../../shared/components/Button';

function CarouselListItem({ item, dragHandleProps, commonProps: { onItemRemove } }) {
  return (
    <div>
      <Row className="">
        <Col xs="2" md="2">
          <i className="fas fa-grip-lines" {...dragHandleProps} />
        </Col>
        <Col xs="6" md="6">
          { (item.fileUrl.slice(-4) == '.mp4') ? (
            <video controls className='w-100'>
              <source src={item.fileUrl}></source>
            </video>
          ) : (
            <Image fluid src={item.fileUrl} />
          )}
        </Col>
        <Col xs="4" md="4">
          <Button onClick={() => onItemRemove(item)}>
            Remove
          </Button>
          {/* TODO: implement in future task */}
          {/* <Button onClick={() => onReplace(item)}>
            Replace
          </Button> */}
        </Col>
      </Row>
      <hr />
    </div>
  );
}

export default CarouselListItem;